<div id="top-header-container">
    <ul>
        <li><a href="#">DJI Madrid</a></li>
        <li><a href="tel:+34666666666">Tlfn: 911 77 73 21</a></li>
        <li><a href="mailto:lorem@ipsum.com">Email: lorem@ipsum.com</a></li>
    </ul>

</div>